import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { SET_PRINTING } from './constants';

const intialState = {
  isPrinting: false,
};

export const printingReducer = createReducer(intialState, {
  [SET_PRINTING]: (state, payload) => {
    return {
      ...state,
      isPrinting: payload.action,
    };
  },
});
